import triggerAllApiEvents from '../triggerAllApiEvents';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { getAdapter } from 'owa-addins-adapters';
import { RecipientFieldEnum } from 'owa-addins-apis-types';
import { getComposeHostItemIndex } from 'owa-addins-store';
import { OutlookEventDispId } from '../schema/OutlookEventDispId';

export function triggerRecipientsChangedEvent(itemId: string, recipientField: RecipientFieldEnum) {
    const hostItemIndex = getComposeHostItemIndex(itemId);
    const adapter = getAdapter(hostItemIndex);
    if (
        adapter != null &&
        (adapter.mode === ExtensibilityModeEnum.AppointmentOrganizer ||
            adapter.mode === ExtensibilityModeEnum.MessageCompose)
    ) {
        let result = null;
        if (adapter.mode == ExtensibilityModeEnum.MessageCompose) {
            result = { to: false, cc: false, bcc: false };
            switch (recipientField) {
                case RecipientFieldEnum.To:
                    result.to = true;
                    break;
                case RecipientFieldEnum.Cc:
                    result.cc = true;
                    break;
                case RecipientFieldEnum.Bcc:
                    result.bcc = true;
                    break;
            }
        } else if (adapter.mode === ExtensibilityModeEnum.AppointmentOrganizer) {
            result = { requiredAttendees: false, optionalAttendees: false, resources: false };
            switch (recipientField) {
                case RecipientFieldEnum.RequiredAttendees:
                    result.requiredAttendees = true;
                    break;
                case RecipientFieldEnum.OptionalAttendees:
                    result.optionalAttendees = true;
                    break;
                case RecipientFieldEnum.Resources:
                    result.resources = true;
                    break;
            }
        }

        triggerAllApiEvents(
            hostItemIndex,
            OutlookEventDispId.RECIPIENTS_CHANGED_EVENT_DISPID,
            () => {
                return result;
            }
        );
    }
}
